import { PROYECT, api_get, api_post, api_put, api_delete } from "../../../services/api";
import { setSnackbar, startRequestComp, stopRequestComp} from "../search/searchActions";
import { COVERAGES_TYPES } from "../../reducers/coverages/coveragesTypes";

const {
  SET_COVERAGES,
  CLEAR_COVERAGES,
  NEW_COVERAGE,
  EDIT_COVERAGE_MODE,
  ADD_COVERAGE,
  SET_NEW_COVERAGE,
  SET_SELECTED_COVERAGE,
  SET_EDITED_COVERAGE,
  DELETE_COVERAGE_MODE,
  SET_DELETED_COVERAGE,
  SET_BRANDS,
  HANDLE_COVERAGES_INPUTS,
} = COVERAGES_TYPES;

const getUrlCoverages = stationID =>
  `${process.env.REACT_APP_URL}${PROYECT}/routes/polygons?stations=${stationID}`;

export function newCapture() {
  return {
    type: NEW_COVERAGE
  };
}
export function clearCaptures() {
  return {
    type: CLEAR_COVERAGES
  };
}

export function deleteCoverageMode() {
  return {
    type: DELETE_COVERAGE_MODE
  };
}

export function editCoverageMode() {
  return {
    type: EDIT_COVERAGE_MODE
  };
}

export function setSelectedCoverage(id) {
  return {
    type: SET_SELECTED_COVERAGE,
    payload: id
  };
}

export function setStationBrands(brands) {
  return {
    type: SET_BRANDS,
    payload: brands
  };
}

export const addCoverageMode = () => {
  return {
    type: ADD_COVERAGE
  };
};

export const handleCoveragesInputsAction = (key, value) => dispatch => {
  dispatch({ type: HANDLE_COVERAGES_INPUTS, payload: { key, value } });
};

export const deleteCoverage = (id, callback) => async (dispatch) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/polygons/${id}`;
  dispatch(startRequestComp('deleteCoverage'));
  try {
    await api_delete(url);
    dispatch({
      type: SET_DELETED_COVERAGE,
      payload: id
    });
    dispatch(setSnackbar('La cobertura se ha eliminado con éxito', 'success'));
    if (callback) callback(false);
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp('deleteCoverage'));
  }
};

export const editCoverage = (id, form, callback) => async (dispatch) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/polygons`;
  dispatch(startRequestComp('editCoverage'));
  try {
    const resp = await api_put(url, { ...form, id });
    dispatch({
      type: SET_EDITED_COVERAGE,
      payload: resp
    });
    dispatch(setSnackbar('La cobertura se ha modificado con éxito', 'success'));
    if (callback) callback(false);
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp('editCoverage'));
  }
};

export const createNewCoverage = (form, callback) => async (dispatch) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/polygons`;
  dispatch(startRequestComp('newCoverage'));
  try {
    const resp = await api_post(url, form);
    dispatch({
      type: SET_NEW_COVERAGE,
      payload: resp
    });
    dispatch(setSnackbar('La cobertura se ha guardado con éxito', 'success'));
    if (callback) callback(false);
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp('newCoverage'));
  }
};

export const fetchCoverages = (idStation = null) => async (dispatch) => {
  dispatch(startRequestComp("fetchCoverages"));
  try {
    const coverages = await api_get(getUrlCoverages(idStation));
    dispatch({
      type: SET_COVERAGES,
      payload: {
        coverages
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("fetchCoverages"));
  }
};